import type { PartialFeedbackPayload } from "@asurion-core/expert-workspace-feedback";

import { STANDALONE_EXPERT_ASSIST_APP_NAME } from "@asurion-core/expert-workspace-feedback";

import { useExpertAssistStore } from "../../state";

export const useFeedbackPayload = (): Omit<PartialFeedbackPayload, "caller"> => {
    const { sessionId, callSid, token, partner } = useExpertAssistStore();

    return {
        appName: STANDALONE_EXPERT_ASSIST_APP_NAME,
        callSid,
        feedbackType: "NoTextFeedback",
        sessionId,
        partner,
        ssoAccessToken: token ?? "",
        extraData: { "Expert Assist Type": "Reactive" },
    };
};
